import { Helmet } from 'react-helmet-async'
import { useIntl } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { ContactDetails } from '@flix/common/domain/legal/ContactDetails/ContactDetails'
import { MaxWidthView } from '@flix/common/elements/layout'
import { H1 } from '@flix/common/elements/typography'
import { canonicalUrl } from '../../../utils/htmlHead'
import meta from '../../metaDescriptions'

const Container = styled(MaxWidthView)`
  padding: 0 ${(props) => props.theme.spacing.md}px ${(props) => props.theme.spacing.xlg}px;
  align-items: flex-start;
`

const PageTitleWrapper = styled(View)`
  padding-top: ${(props) => props.theme.spacing.lg}px;
`

const ContactUsPage = ({ location, pageTitle = 'Contact Us', showAddresses }) => {
  const intl = useIntl()
  return (
    <Container>
      <Helmet>
        <title>{intl.formatMessage(meta.contactTitle)}</title>
        <meta property="og:title" content="Contact Flix Premiere" />
        <meta
          name="description"
          property="og:description"
          content={intl.formatMessage(meta.contact)}
        />
        <meta property="og:url" content={canonicalUrl(location)} />
        <link rel="canonical" href={canonicalUrl(location)} />
      </Helmet>

      <PageTitleWrapper>
        <H1>{pageTitle}</H1>
      </PageTitleWrapper>
      <ContactDetails
        showAddresses={showAddresses}
        openMail={(email) => window.open(`mailto:${encodeURIComponent(email)}`)}
      />
    </Container>
  )
}

ContactUsPage.propTypes = {
  showAddresses: PropTypes.bool,
  pageTitle: PropTypes.string,
}

export default ContactUsPage
